import * as React from "react";
import type { SVGProps } from "react";
const SvgRedditIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M9.478 12c.63 0 1.145.515 1.145 1.145s-.514 1.145-1.145 1.145c-.63 0-1.145-.515-1.145-1.145S8.848 12 9.478 12ZM12.013 17.005c.437 0 1.93-.052 2.714-.837a.33.33 0 0 0 .026-.424.303.303 0 0 0-.424 0c-.502.489-1.544.669-2.303.669-.76 0-1.814-.18-2.303-.67a.303.303 0 0 0-.425 0 .303.303 0 0 0 0 .425c.772.772 2.277.837 2.715.837ZM13.377 13.145c0 .63.514 1.145 1.145 1.145.63 0 1.145-.515 1.145-1.145S15.152 12 14.522 12s-1.145.515-1.145 1.145Z"
    />
    <path
      fill="currentColor"
      d="M23 12c0 6.075-4.925 11-11 11S1 18.075 1 12 5.925 1 12 1s11 4.925 11 11Zm-5.275-1.608c-.437 0-.823.167-1.106.45-1.094-.785-2.612-1.3-4.284-1.364l.733-3.435 2.38.502a1.146 1.146 0 0 0 2.29-.051c0-.63-.515-1.145-1.145-1.145-.45 0-.836.257-1.016.643l-2.664-.566a.32.32 0 0 0-.218.038.313.313 0 0 0-.129.18l-.81 3.834c-1.712.052-3.243.554-4.349 1.364a1.623 1.623 0 0 0-1.106-.45 1.609 1.609 0 0 0-.657 3.075 3.01 3.01 0 0 0-.038.489c0 2.47 2.869 4.464 6.42 4.464 3.55 0 6.42-1.994 6.42-4.465 0-.167-.013-.321-.039-.476.527-.257.926-.823.926-1.479 0-.888-.72-1.608-1.608-1.608Z"
    />
  </svg>
);
export default SvgRedditIcon;
